/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_CrumbInputs */

const en_auth_signup_crumb = /** @type {(inputs: Auth_Signup_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signup`)
};

const pl_auth_signup_crumb = /** @type {(inputs: Auth_Signup_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestracja`)
};

/**
* | output |
* | --- |
* | "Signup" |
*
* @param {Auth_Signup_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_crumb = /** @type {((inputs?: Auth_Signup_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_crumb(inputs)
	return en_auth_signup_crumb(inputs)
});